export function getReturnToOfferButton(action: () => void) {
    return {
        primary: {
            action,
            buttonStyle: 'secondary',
            label: 'Return to Offer',
            customIdentifiers: {
                primaryButton: {
                    dataTestId: 'return-to-offer-button'
                }
            }
        }
    } as const;
}
